import { useEffect } from 'react';

const SITE_NAME = 'Motion Reality';
const DEFAULT_TITLE = 'Motion Reality — Premium Sim Racing Hardware & Sim Experiences';
const DEFAULT_DESCRIPTION =
  'Motion Reality — bespoke racing simulators, pro-spec sim racing hardware and sim racing experience bookings in Bromborough, UK. Next day delivery on hardware orders before 2pm.';
const DEFAULT_IMAGE =
  'https://media.base44.com/images/public/69e75b1fdf3eee5e6d1453dc/de63d0e06_generated_66d7d18e.png';

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  if (content !== undefined && content !== null && content !== '') {
    el.setAttribute('content', content);
  }
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * Canonicalises a URL to the https://motionreality.co.uk origin on the
 * production domain so the canonical / og:url always matches the apex variant
 * declared in index.html — regardless of whether the page was reached via
 * http, www, or query-stringed links. Preview/staging domains are left
 * untouched.
 */
function canonicalizeUrl(raw) {
  try {
    const u = new URL(raw, window.location.origin);
    if (u.hostname === 'motionreality.co.uk' || u.hostname === 'www.motionreality.co.uk') {
      u.protocol = 'https:';
      u.hostname = 'motionreality.co.uk';
    }
    return u.href;
  } catch {
    return raw;
  }
}

export function setSeo({ title, description, image, url, type = 'website', jsonLd } = {}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
  document.title = fullTitle;

  const desc = description || DEFAULT_DESCRIPTION;
  const img = image || DEFAULT_IMAGE;
  const pageUrl = canonicalizeUrl(url || window.location.href);

  upsertMeta('name', 'description', desc);
  upsertMeta('property', 'og:title', fullTitle);
  upsertMeta('property', 'og:description', desc);
  upsertMeta('property', 'og:image', img);
  upsertMeta('property', 'og:url', pageUrl);
  upsertMeta('property', 'og:type', type);
  upsertMeta('property', 'og:site_name', SITE_NAME);
  upsertMeta('name', 'twitter:card', 'summary_large_image');
  upsertMeta('name', 'twitter:title', fullTitle);
  upsertMeta('name', 'twitter:description', desc);
  upsertMeta('name', 'twitter:image', img);
  upsertLink('canonical', pageUrl);

  let script = document.getElementById('page-jsonld');
  if (script) script.remove();
  if (jsonLd) {
    script = document.createElement('script');
    script.id = 'page-jsonld';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(script);
  }
}

export function useSeo(opts) {
  useEffect(() => {
    setSeo(opts);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(opts)]);
}